<span class="client-credit-title">
  <span>{{
    (credit?.contractTime ? 'credits.creditTitleTemplate' : 'credits.creditRequestTitleTemplate')
      | translate: { creditId: credit?.id || '', clientFullName: (credit?.user | clientFullName) || '' }
  }}</span>
  @if (credit?.user?.id) {
    @let state = state$ | async;
    <span class="client-credit-title__presence client-credit-title__presence--{{ state }}"
          [matTooltip]="'clients.livePresence.' + state | translate"
          matTooltipPosition="below">{{ 'clients.livePresence.short.' + state | translate }}</span>
  }
</span>
